export const ADD_SONGS = "ADD_SONGS"
export const REMOVE_SONGS = "REMOVE_SONGS"
export const TOGGLE_PLAYING = "TOGGLE_PLAYING"
export const TOGGLE_FAVORITE = "TOGGLE_FAVORITE"
export const PLAY_SONG = "PLAY_SONG"
export const SHUFFLE = "SHUFFLE"
export const SET_SHUFFLE = "SET_SHUFFLE"
export const REPEAT = "REPEAT"
export const NEW_PLAYLIST = "NEW_PLAYLIST"
export const ADD_SONG_TO_PLAYLIST = "ADD_SONG_TO_PLAYLIST"
